import axios from "axios";

const getBackendUrl = () => {
  if (typeof window !== "undefined" && window.location) {
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
    }
    // In production web, always use relative path to prevent any cross-origin CORS issues
    return "";
  }
  return process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";
};

export const api = axios.create({
  baseURL: `${getBackendUrl()}/api`,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("telemed_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}
